import React, { useRef, useState } from 'react';
import {
  Box,
  CircularProgress,
  IconButton,
  Paper,
  TextField,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { chatInputWrapper, inputField, buttonsWrapper } from '../styles';
import { useInteractionHealthCheck } from '../hooks/use-health-check';

type Props = {
  onSend: (msg: string) => void | Promise<void>;
  loading: boolean;
};

export const ChatInput: React.FC<Props> = ({ onSend, loading }: Props) => {
  const [message, setMessage] = useState('');
  const checkHealth = useInteractionHealthCheck();
  const formRef = useRef<HTMLFormElement | null>(null);

  const handleSend = () => {
    if (!message.trim() || loading) return;
    checkHealth();
    void onSend(message);
    setMessage('');
  };

  return (
    <Paper
      component="form"
      ref={formRef}
      sx={chatInputWrapper}
      onFocus={checkHealth}
      onSubmit={e => {
        e.preventDefault();
        handleSend();
      }}>
      <TextField
        multiline
        maxRows={5}
        variant="standard"
        placeholder="Ask anything"
        value={message}
        onFocus={checkHealth}
        onChange={e => setMessage(e.target.value)}
        InputProps={{ disableUnderline: true }}
        sx={inputField}
      />
      <Box sx={buttonsWrapper}>
        <div></div>
        {loading ? (
          <CircularProgress
            variant="indeterminate"
            size={20}
            color="secondary"
            thickness={1}
          />
        ) : (
          <IconButton onClick={handleSend}>
            <SendIcon />
          </IconButton>
        )}
      </Box>
    </Paper>
  );
};
